import { gql } from "@apollo/client";

const BORRAR_DOCUMENTOS_CAPA = gql`
    mutation borrarDocumentoCapa($idArchivo: Int!){
        borrarDocumentoCapa(idArchivo: $idArchivo){
            success
        }
    }
`;

export default BORRAR_DOCUMENTOS_CAPA;